"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressArc = void 0;
const react_1 = require("@emotion/react");
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const React = __importStar(require("react"));
const Svg = styled_1.default.svg `
  display: block;
  margin: 1em auto;
  height: 100%;
  width: 100%;

  circle {
	fill: none;
    transform: rotate(-90deg);
	animation: ${(props) => props.keyframe} 2s ease forwards;
  }

  text {
    font-weight: 600;
    text-anchor: middle;
  }
`;
const ProgressArc = ({ value = 45, change, goalValue, gradientColors = [merlin_theme_1.default.paletteV5.pink.primary, merlin_theme_1.default.paletteV5.purple.primary, merlin_theme_1.default.paletteV5.green.primary], arcBackgroundColor = '#eceeef', radius = 120, dimmed, }) => {
    const max = 100;
    const r = radius;
    const p = 2 * r * Math.PI;
    const offset = p - (value / max) * p;
    const arcStrokeWidth = r / 6;
    const height = r * 2 + arcStrokeWidth * 2;
    const c = r + arcStrokeWidth;
    const textSize = {
        small: `${r / 7}px`,
        med: `${r / 3.5}px`,
        lg: `${r / 2.5}px`
    };
    // keyframe @emotion helper avoids namespace conflicts when multiple instances
    // are used on the same page
    const keyframe = (0, react_1.keyframes) `
		0% {
			stroke-dashoffset: ${p};
		}
		100% {
			stroke-dashoffset: ${offset};
		}
	`;
    return (React.createElement(React.Fragment, null,
        React.createElement(Svg, { viewBox: `0 0 ${height} ${height}`, height: height, keyframe: keyframe, "data-testid": "progress-arc--svg", opacity: dimmed ? 0.6 : 1 },
            React.createElement("defs", null,
                React.createElement("linearGradient", { id: "grad1", gradientTransform: "rotate(90)" },
                    React.createElement("stop", { offset: "50%", stopColor: gradientColors[2] }),
                    React.createElement("stop", { offset: "80%", stopColor: gradientColors[1] })),
                React.createElement("linearGradient", { id: "grad2", gradientTransform: "rotate(90)" },
                    React.createElement("stop", { offset: "50%", stopColor: gradientColors[0] }),
                    React.createElement("stop", { offset: "80%", stopColor: gradientColors[1] })),
                React.createElement("pattern", { id: "pattern", x: "0", y: "0", width: height, height: height, patternUnits: "userSpaceOnUse" },
                    React.createElement("g", { transform: `rotate(90, ${c}, ${c})` },
                        React.createElement("rect", { shapeRendering: "crispEdges", x: "0", y: "0", width: height / 2, height: height, fill: "url(#grad1)" }),
                        React.createElement("rect", { shapeRendering: "crispEdges", x: height / 2, y: "0", width: height, height: height, fill: "url(#grad2)" })))),
            React.createElement("circle", { r: r, cx: -c, cy: c, stroke: arcBackgroundColor, strokeWidth: arcStrokeWidth }),
            React.createElement("circle", { r: r, cx: -c, cy: c, stroke: 'url("#pattern")', strokeWidth: arcStrokeWidth, strokeDashoffset: p, strokeDasharray: p }),
            React.createElement("text", { x: c, y: change ? c : c + r / 6, fontSize: textSize.lg, dominantBaseline: "auto", "data-testid": "progress-arc--score-text" },
                value,
                React.createElement("tspan", { fontSize: textSize.med },
                    "/",
                    max)),
            goalValue &&
                React.createElement(React.Fragment, null,
                    React.createElement("line", { x1: c, y1: c - r + (arcStrokeWidth / 2), x2: c, y2: c - r - arcStrokeWidth, stroke: "black", strokeWidth: "2", transform: `rotate(${(goalValue / max) * 360}, ${c}, ${c})`, "data-testid": "progress-arc--goal-line" }),
                    React.createElement("text", { x: r / 6, y: r / 4, fontSize: textSize.small, "data-testid": "progress-arc--goal-text" }, goalValue)),
            change &&
                React.createElement(React.Fragment, null,
                    React.createElement("rect", { fill: change > 0 ? gradientColors[gradientColors.length - 1] : gradientColors[0], x: c - r / 4, y: c + r / 6, width: r / 1.75, height: r / 3.5, rx: r / 6, "data-testid": "progress-arc--change-rect" }),
                    React.createElement("text", { x: c, y: c + r / 6 + r / 9 + r / 12, fontSize: textSize.small, dominantBaseline: "auto", "data-testid": "progress-arc--change-text" }, `${change > 0 ? '▲' : '▼'} ${Math.abs(change)}`)))));
};
exports.ProgressArc = ProgressArc;
//# sourceMappingURL=ProgressArc.js.map